import { Breadcrumbs } from 'components/elements/Breadcrumbs'
import React from 'react'
import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters/index'
import { Container } from 'components/layout'
import { Asset } from 'services/ContentfulService/models/asset'
import { Breadcrumb } from 'shared/layout/CustomHead/Schemas/breadcrumbSchema'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'

interface Props {
	title: string
	asset: Asset
	subtitle?: string
	breadcrumbs?: Breadcrumb[]
}

export const TopicHero: React.FC<React.PropsWithChildren<Props>> = ({ title, asset, subtitle, breadcrumbs }) => {
	return (
		<Hero>
			<HeroContainer>
				<Left>
					{breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
					<H1>{title}</H1>
					{subtitle && <p>{subtitle}</p>}
				</Left>
				<Right aspectRatio={asset.aspectRatio || 1}>
					<InlineSvg asset={asset} />
				</Right>
			</HeroContainer>
		</Hero>
	)
}

const H1 = styled.h1`
	max-width: 544px;
	margin-top: 16px;
	line-height: 1.45;
	z-index: 3;
`
const Hero = styled.div`
	width: 100%;
	background: #f9f2ff;
	align-items: center;
	position: relative;
	margin-bottom: 10px;
`

const Right = styled.div<{ aspectRatio: number }>`
	display: flex;
	align-items: flex-end;
	max-width: ${props => props.aspectRatio * 130}px;
	padding-right: 20px;
	${mediaQueriesByDevice.mobilePortrait} {
		position: absolute;
		height: ${props => (props.aspectRatio > 1.8 ? '90px' : '100px')};
		bottom: 0;
		right: 0;
		opacity: 15%;
	}
`

const Left = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
	flex: 1 1 auto;
`

const HeroContainer = styled(Container)`
	width: 100%;
	display: flex;
	padding: unset;
	height: 100%;
	position: relative;
	flex-direction: row;
	justify-content: space-between;
`
